import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Grid, Typography } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import Pagination from "@mui/material/Pagination";
import LearningCard from "./LearningCard"; // Import the LearningCard component
import { CustomPaginationCommon } from "modules/Users/components";
import { useNavigate } from "react-router-dom";
import { Purchase } from "types";
import { PurchasesService } from "services/PurchasesService";
import dayjs from "dayjs";
import { LearningLogService } from "services/LearningLogService";
import { useAuth } from "context/authContext";
import jsPDF from "jspdf";


type MyLearningDataProps = {
  purchasesData: Purchase[];
  loading: boolean;

};

const MyLearningData: React.FC<MyLearningDataProps> = ({
  purchasesData,
  loading,
}) => {
  const { currentUser } = useAuth();
  const [page, setPage] = useState(0);
  const [progressData, setProgressData] = useState<{ [key: string]: number }>({});
  const [rowsPerPage, setRowsPerPage] = useState(3);



  // ✅ Fetch progress data from Firestore when the page loads
  useEffect(() => {
    const fetchProgressData = async () => {
      if (!currentUser) return;

      const progressMap: { [key: string]: number } = {};

      for (const item of purchasesData) {
        const progress = await LearningLogService.getProgress(currentUser.uid, item.id);
        progressMap[item.id] = progress;
      }

      setProgressData(progressMap);
    };

    fetchProgressData();
  }, [currentUser, purchasesData]); // ✅ Runs when purchasesData updates



  const itemsPerPage = 6;
  const navigate = useNavigate();



  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage);
  };

  const getPaginatedData = () => {
    const startIndex = page * rowsPerPage; // ✅ Use zero-based index
    return purchasesData.slice(startIndex, startIndex + rowsPerPage);
  };




  const handleStartClick = async (item: any, cartItem: any) => {

    const id = item?.id;

    const userId = item?.userId; // Make sure this is valid
    const contentId = item?.id;
    const sectionId = cartItem?.contentData?.contentStructure?.[0]?.id || "default_section";
    const contentTitle = cartItem?.contentData?.title || "Unknown Title";


    try {


      // Log the last accessed date in Firestore
      await LearningLogService.createOrUpdateLearningLog(userId, contentId, sectionId, contentTitle);

    } catch (error) {
      console.error("❌ Error updating last accessed date:", error);
    }

    // Redirect logic based on type
    if (cartItem?.contentData?.type === "handout") {
      navigate(`/education-content-handout/${id}`);
    } else if (cartItem?.contentData?.type === "course") {
      navigate(`/education-content-course/${id}`);
    } else {
      console.warn("Unknown content type:", cartItem?.contentData?.type);
    }

    // ✅ Update progress state to show progress bar and "Continue" button
    setProgressData((prev) => ({ ...prev, [contentId]: 20 })); // ✅ Update UI

    window.scrollTo({ top: 0, behavior: "smooth" });

  };

  const handleContinueClick = async (item: any, cartItem: any) => {
    const id = item?.id;

    const userId = item?.userId; // Make sure this is valid
    const contentId = item?.id;
    const sectionId = cartItem?.contentData?.contentStructure?.[0]?.id || "default_section";
    const contentTitle = cartItem?.contentData?.title || "Unknown Title";

    // Log the last accessed date in Firestore
    await LearningLogService.createOrUpdateLearningLog(userId, contentId, sectionId, contentTitle);

    // Redirect logic can be similar to handleStartClick
    if (cartItem?.contentData?.type === "handout") {
      navigate(`/education-content-handout/${id}`);
    } else if (cartItem?.contentData?.type === "course") {
      navigate(`/education-content-course/${id}`);
    } else {
      console.warn("Unknown content type:", cartItem?.contentData?.type);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });

  };
  console.log("purchasesData", purchasesData);

  // const handleDownloadClick = (item: any) => {
  //   console.log("dounload clicked", item);

  //   item?.cartItemData?.forEach((cartItem: any) => {
  //     const contentStructure = cartItem?.contentData?.contentStructure;

  //     if (contentStructure && Array.isArray(contentStructure)) {
  //       contentStructure.forEach((content: any) => {
  //         if (content?.fileUrl) {
  //           // Create a direct download link
  //           const anchor = document.createElement("a");
  //           anchor.href = content.fileUrl; // Firebase's file URL
  //           anchor.download = content?.fileName || "file"; // Set a default file name
  //           anchor.target = "_blank"; // Open in the same window/tab
  //           document.body.appendChild(anchor); // Append the anchor
  //           anchor.click(); // Trigger download
  //           document.body.removeChild(anchor); // Remove after clicking
  //         } else {
  //           console.warn("File URL not found in content structure.");
  //         }
  //       });
  //     } else {
  //       console.warn("No valid contentStructure available for this cart item.");
  //     }
  //   });
  // };

  // 🔁 Triggered when the "Download" button is clicked
  // Triggered when the "Download" button is clicked





  const handleDownloadClick = (item: any, cartItem: any) => {
    const safeData = {
      title: cartItem?.contentData?.title,
      contentStructure: cartItem?.contentData?.contentStructure,
    };

    navigate(`/view-content-structure/${item.id}`, {
      state: { data: safeData },
    });
  };



  // const handleDownloadClick = async (cartItem: any) => {
  //   const doc = new jsPDF();
  //   let y = 10; // Y-position for text

  //   const contentStructure = cartItem?.contentData?.contentStructure;

  //   if (!Array.isArray(contentStructure) || contentStructure.length === 0) {
  //     console.warn("❌ No valid contentStructure for download.");
  //     return;
  //   }

  //   for (const section of contentStructure) {
  //     const sectionTitle = section?.title || "Untitled Section";
  //     // ✅ Title (clean font)
  //     doc.setFont("helvetica", "bold");
  //     doc.setFontSize(14);
  //     doc.text(`${sectionTitle}`, 10, y);
  //     y += 10;

  //     // CASE 1: section.files array
  //     if (Array.isArray(section?.files)) {
  //       for (const file of section.files) {
  //         const fileUrl = file?.fileUrl || file?.url;
  //         if (fileUrl) {
  //           const wrapped = doc.splitTextToSize(fileUrl, 180); // wraps text

  //           for (const line of wrapped) {
  //             doc.setFont("helvetica", "normal");
  //             doc.text(line, 10, y); // 👁 visible
  //             doc.link(10, y - 3, 180, 8, { url: fileUrl }); // 🔗 clickable
  //             y += 7;
  //           }
  //         }
  //       }
  //     }


  //     // CASE 2: direct file
  //     else if (section?.fileUrl || section?.url) {
  //       const fileUrl = section.fileUrl || section.url;
  //       doc.textWithLink(fileUrl, 10, y, { url: fileUrl });
  //       y += 8;
  //     }

  //     y += 5;

  //     // Check if PDF is running out of space
  //     if (y > 270) {
  //       doc.addPage();
  //       y = 10;
  //     }
  //   }

  //   doc.save("MyLearningResources.pdf"); // 💾 Download PDF
  // };













  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage); // ✅ Zero-based pagination
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // ✅ Reset to first page when rows per page changes
  };



  const handleLearningLog = () => {
    navigate("/learning-log");
  };

  return (
    <Grid position="relative" justifyContent="center">
      <Grid
        item
        xs={12}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        gap={3}
        px={{ xs: 2, md: "55px" }}
      // height={"100%"}
      >
        <Box
          px={1}
          pt={{ xs: 17, md: 5 }}
          // width={"100%"}
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Box
            fontWeight={500}
            fontSize="28px"
            color="#233F91"
            display="flex"
            alignItems="center"
          >
            My Learning
          </Box>
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 700,
              borderBottom: "1px solid #233F91",
              color: "#233F91",
              cursor: "pointer",
            }}
            onClick={handleLearningLog}
          >
            View Learning Log
          </Typography>
        </Box>
        <Grid
          container
        // spacing={2}
        >
          {loading ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="70vh"
              width="100vw"
            >
              <CircularProgress sx={{ color: "#233F91" }} />
            </Box>

          ) : purchasesData.length === 0 ? (
            <Box
              flex={1}
              display="flex"
              alignItems={"center"}
              justifyContent={"center"}
              width="100vw"
            >
              <Typography
                display="flex"
                alignItems="center"
                fontSize={22}
                color="#797979"
                fontWeight={400}
              >
                Your cart is empty
              </Typography>
            </Box>
          ) : (
            <>

              {getPaginatedData().map((item) => {

                return (

                  <Grid item xs={12} key={item.id}>
                    <LearningCard
                      item={item}
                      showProgressBar={true}
                      showLastAccessed={true}

                      onStartClick={(cartItem: any) =>
                        handleStartClick(item, cartItem)
                      }
                      onContinueClick={(cartItem: any) =>
                        handleContinueClick(item, cartItem)
                      }
                      // onDownloadClick={() => handleDownloadClick(item)}
                      onDownloadClick={(cartItem: any) => handleDownloadClick(item, cartItem)}

                      progress={progressData[item.id] || 0} // ✅ Pass progress from Firestore
                    />
                  </Grid>
                )
              })}
            </>
          )}
        </Grid>
      </Grid>
      {loading ? null : (
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignContent={"center"}
          m={5}
        >
          {/* <CustomPaginationCommon
            count={Math.ceil(purchasesData.length / itemsPerPage)}
            page={page}
            rowsPerPage={itemsPerPage}
            onPageChange={handlePageChange}
          /> */}
          <CustomPaginationCommon
            count={purchasesData.length}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      )}

    </Grid >
  );
};

export default MyLearningData;
